var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7605 21.6401C18.6772 21.6401 16.6189 21.1861 14.5855 20.2781C12.5522 19.3701 10.7022 18.0825 9.03555 16.4151C7.36888 14.7485 6.08155 12.8985 5.17355 10.8651C4.26555 8.8318 3.81121 6.77347 3.81055 4.69014C3.81055 4.39014 3.91055 4.14014 4.11055 3.94014C4.31055 3.74014 4.56055 3.64014 4.86055 3.64014H8.91055C9.14388 3.64014 9.35221 3.71947 9.53555 3.87814C9.71888 4.0368 9.82721 4.22414 9.86055 4.44014L10.5105 7.94014C10.5439 8.2068 10.5355 8.4318 10.4855 8.61514C10.4355 8.79847 10.3439 8.9568 10.2105 9.09014L7.78555 11.5401C8.11888 12.1568 8.51455 12.7525 8.97255 13.3271C9.43055 13.9018 9.93488 14.4561 10.4855 14.9901C11.0022 15.5068 11.5439 15.9861 12.1105 16.4281C12.6772 16.8701 13.2772 17.2741 13.9105 17.6401L16.2605 15.2901C16.4105 15.1401 16.6065 15.0278 16.8485 14.9531C17.0905 14.8785 17.3279 14.8575 17.5605 14.8901L21.0105 15.5901C21.2439 15.6568 21.4355 15.7778 21.5855 15.9531C21.7355 16.1285 21.8105 16.3241 21.8105 16.5401V20.5901C21.8105 20.8901 21.7105 21.1401 21.5105 21.3401C21.3105 21.5401 21.0605 21.6401 20.7605 21.6401Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsCall);
export default __webpack_public_path__ + "static/media/material-symbols_call.81c6b9f6df7776c322c2839a319e2672.svg";
export { ForwardRef as ReactComponent };